// Types matching the BE serializer response shapes

export interface InvoiceListItem {
  id: string | number;
  title: string;
  transaction_count: number;
}

export interface OrgPublication {
  id: number;
  name: string;
  account_id?: number;
}

export interface OrgAccount {
  id: number;
  name: string;
}

export interface InvoiceListResponse {
  current_invoice: InvoiceListItem | null;
  invoices: InvoiceListItem[];
  current_page: number;
  total_pages: number;
  publication_inactive: boolean;
  publications: OrgPublication[];
  accounts: OrgAccount[];
}

export interface ChargeBreakdownItem {
  category: string;
  amount: number;
}

export interface Transaction {
  title: string | null;
  story_url: string | null;
  category: string;
  campaigns: string | null;
  story_id: number | null;
  contributor: string | null;
  date: string | null;
  notes: string | null;
  amount: number;
  is_credit: boolean;
}

export interface InvoicePeriod {
  id: string | number;
  label: string;
  url: string;
}

export interface InvoiceDetailResponse {
  invoice: {
    id: string | number;
    title: string;
    display_id: string;
    filename: string;
    purchase_order_number?: string;
  };
  publication_name: string;
  new_charges: {
    total: number;
    breakdown: ChargeBreakdownItem[];
  };
  credits: number;
  pending_payments?: number;
  all_periods: InvoicePeriod[];
  transactions: Transaction[];
  publications: OrgPublication[];
  accounts: OrgAccount[];
}

const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export async function fetchInvoiceList(
  publicationId: string,
  page = 1
): Promise<InvoiceListResponse> {
  const res = await fetch(
    `/publications/${publicationId}/invoices.json?page=${page}`,
    { credentials: 'same-origin', headers: HEADERS }
  );
  if (!res.ok) throw new Error(`Failed to fetch invoice list: ${res.status}`);
  return res.json();
}

export async function fetchInvoiceDetail(
  publicationId: string,
  invoiceId: string
): Promise<InvoiceDetailResponse> {
  const res = await fetch(
    `/publications/${publicationId}/invoices/${invoiceId}.json`,
    { credentials: 'same-origin', headers: HEADERS }
  );
  if (!res.ok) throw new Error(`Failed to fetch invoice detail: ${res.status}`);
  return res.json();
}
